import { ButtonPrimary, InfoFeedbackScreen, Stack, Text4, skinVars } from '@telefonica/mistica';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import './index.scss';
import { useNavigate, useLocation } from 'react-router-dom';
import navigateParams from '../../../utils/navigation/navigateParams';
import { TrackingEvents } from '../../../utils/dataTransformation/tracking';
import { isWebviewAndroid, isWebviewIOS } from '../../../utils/navigation/controlDevices';

type IFeedbackLiterals = {
    title: string;
    description: string;
};

type IActionsGeedbackConfigureLine = {
    active: IFeedbackLiterals;
    desactivated: IFeedbackLiterals;
};

type IFeedbackConfigureLine = {
    roaming: IActionsGeedbackConfigureLine;
    'blocked-number-specials': IActionsGeedbackConfigureLine;
};

const ConfigureLineFeedback: React.FC = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { trackingScreenView } = new TrackingEvents();
    let { pathname, state } = useLocation();
    const roaming = sessionStorage.getItem('roaming');
    const blockedNumberSpecials = sessionStorage.getItem('numbersSpecials');

    const sendToNative = (url: string, title: string) => {
        const type = 'modeFlow-backgroundBlue';
        const productId = state.productId;
        const phone = state.phone;
        const multisim = state.multisim;
        const queryParams = { productId, phone, multisim };

        if (navigateParams(type, url, queryParams, { roaming, blockedNumberSpecials }, title)) {
            navigate(`/configure-line`, {
                state: { ...queryParams },
            });
        }
    };

    const getInfoPreviousPath = () => {
        const path = pathname.split('/');
        return {
            path: `/${path[1]}/${path[2]}`,
            title: path[2],
        };
    };

    const getLiterals = () => {
        const path = pathname.split('/');
        const _type: string = path[2];
        const _operation: string = path[4];
        const isRoaming = _type === 'roaming';
        const isActive = _operation === 'activated';
        let title = '';
        let description = '';
        const actions: IFeedbackConfigureLine = {
            roaming: {
                active: {
                    title: t('activationRequested'),
                    description: t('infoRequestFeedbackActiveRoaming'),
                },
                desactivated: {
                    title: t('desactivationRequested'),
                    description: t('infoRequestFeedbackDesactiveRoaming'),
                },
            },
            'blocked-number-specials': {
                active: {
                    title: t('blockingRequest'),
                    description: t('infoRequestFeedbackActiveNumber'),
                },
                desactivated: {
                    title: t('unlockingRequest'),
                    description: t('infoRequestFeedbackDesactiveNumber'),
                },
            },
        };

        if (isRoaming) {
            if (isActive) {
                title = actions.roaming.active.title;
                description = actions.roaming.active.description;
            } else {
                title = actions.roaming.desactivated.title;
                description = actions.roaming.desactivated.description;
            }
        } else {
            if (isActive) {
                title = actions['blocked-number-specials'].active.title;
                description = actions['blocked-number-specials'].active.description;
            } else {
                title = actions['blocked-number-specials'].desactivated.title;
                description = actions['blocked-number-specials'].desactivated.description;
            }
        }

        const getDescription = () => {
            return (
                <Stack space={32}>
                    <Text4 regular color={skinVars.colors.textSecondary}>
                        {t('requestLoading')}
                    </Text4>
                    <Text4 regular color={skinVars.colors.textSecondary}>
                        {description}
                    </Text4>
                </Stack>
            );
        };

        return {
            title,
            description: getDescription(),
        };
    };

    useEffect(() => {
        if (!(isWebviewAndroid || isWebviewIOS)) {
            trackingScreenView();
        }
    }, []);

    return (
        <div className='ConfigureLineFeedback-page'>
            <InfoFeedbackScreen
                title={getLiterals()?.title}
                description={getLiterals()?.description as any}
                primaryButton={
                    <ButtonPrimary
                        onPress={() => {
                            sendToNative(getInfoPreviousPath().path, getInfoPreviousPath().title);
                        }}
                    >
                        {t('buttonUnderstoodFeedback')}
                    </ButtonPrimary>
                }
            ></InfoFeedbackScreen>
        </div>
    );
};

export default ConfigureLineFeedback;
